import { http as messageHttp } from './http'

export const getUserMessages = params => messageHttp.get('/user/messages', { params })

export const getDispatchInvitations = params => messageHttp.get('/user/dispatchInvitations', { params })

export const markMessageRead = (id, data) => messageHttp.post(`/user/messages/${id}/read`, data)

export const markAllMessagesRead = data => messageHttp.post('/user/messages/readAll', data)

export const deleteUserMessage = (id, userId) => messageHttp.delete(`/user/messages/${id}`, { params: { userId } })

export const clearUserMessages = userId => messageHttp.delete('/user/messages/clearAll', { params: { userId } })

export const acceptDispatchInvitation = (id, data) => messageHttp.post(`/user/dispatchInvitations/${id}/accept`, data)

export const rejectDispatchInvitation = (id, data) => messageHttp.post(`/user/dispatchInvitations/${id}/reject`, data)
